
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"a",attrs:{"d":"M13.045 14.137l-3.712.53.53-3.712 9.546-9.546a2.25 2.25 0 013.182 3.182z"}}),_c('path',{staticClass:"a",attrs:{"d":"M23.25 8.25v13.5a1.5 1.5 0 01-1.5 1.5H2.25a1.5 1.5 0 01-1.5-1.5V5.25a1.5 1.5 0 011.5-1.5h10.5"}}),_c('path',{staticClass:"a",attrs:{"d":"M9 6.75H3.75v13.5h16.5v-9M3.75 11.25h3"}}),_c('path',{staticClass:"a",attrs:{"d":"M3.75 17.25h4.5v3M15.75 17.25h4.5M17.25 14.25h3"}})])
          )
        }
      }
    